module.exports = __webpack_public_path__ + "static/media/BottomBG.0b587368.svg";